import { render, staticRenderFns } from "./Level5-1.vue?vue&type=template&id=2d24f77e&scoped=true&"
import script from "./Level5-1.vue?vue&type=script&lang=js&"
export * from "./Level5-1.vue?vue&type=script&lang=js&"
import style0 from "./Level5-1.vue?vue&type=style&index=0&id=2d24f77e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d24f77e",
  null
  
)

export default component.exports